import { useField } from "formik"
import { PaymentMethodType } from "../../../../../../modules/payments/paymentTypes"
import { SelectedMainUserState } from "../../../../createOrder/createOrderTypes"
import { BuyerPartiesAutocomplete } from "./BuyerPartiesAutocomplete"
import {
    DynamicConfigField,
    DynamicConfigKey,
    PaymentMethodOption,
    PaymentMethodOptionValue,
} from "../../form/formTypes"
import { Logger } from "../../../../../../lib/logging"

type BuyerPartiesControllerProps = Readonly<{
    config: DynamicConfigField
    user: SelectedMainUserState
    isCreateBuyerParty?: boolean
}>

export function BuyerPartiesController({ config, user, isCreateBuyerParty }: BuyerPartiesControllerProps) {
    const [{ value: paymentMethodFieldValue }] = useField<PaymentMethodOption>(DynamicConfigKey.PAYMENT_METHOD)
    const paymentValue: PaymentMethodOptionValue = paymentMethodFieldValue?.value
    const showBuyerParties = paymentValue === PaymentMethodType.INVOICE

    new Logger("create-order").info(
        `Render buyer party field(s)? ${showBuyerParties} [payment method: ${paymentValue}]`,
    )
    return showBuyerParties ? (
        <BuyerPartiesAutocomplete config={config} user={user} showCreateButton={isCreateBuyerParty} />
    ) : null
}
